<template>
  <div class="SidebarLayout-styles-content">
    <h2 class="PersonalDetails-styles-desktop-title">{{ t.informations }}</h2>
    <div class="Paper-styles-paper DesktopTabs-styles-container">
      <div class="DesktopTabs-styles-tabs-container">
        <button @click="changePage(1)" testid="Button_tab_button_0" :class="(page === 1) ? 'TabButton-styles-tab-button-active' : ''" id="tab-button-0" class="Button-styles-button TabButton-styles-tab-button DesktopTabs-styles-tab">
          <div class="">{{ t.navigation.personal_informations }}</div></button>
        <button testid="Button_tab_button_1" id="tab-button-1" class="Button-styles-button TabButton-styles-tab-button DesktopTabs-styles-tab">
          <div class="">{{ t.navigation.contact_informations }}</div></button>
        <button @click="changePage(2)" :class="(page === 2) ? 'TabButton-styles-tab-button-active' : ''" testid="Button_tab_button_2" id="tab-button-2" class="Button-styles-button TabButton-styles-tab-button DesktopTabs-styles-tab">
          <div class="">{{ t.navigation.change_password }}</div></button>
      </div>
      <div class="MyDetails-styles-personal-details MyDetails-styles-desktop" v-if="page === 1">
        <div class="MyDetailsForm-styles-my-details MyDetailsForm-styles-desktop">
          <form class="MyDetailsForm-styles-my-details-form" id="MyDetails" name="MyDetails" fields="[object Object]" errors="[object Object]">
            <div class="InputGroup-styles-input-group MyDetailsForm-styles-field">
              <label class="InputGroup-styles-label" for="MyDetails-fullName-input">First and last name:</label>
              <div class="InputGroup-styles-input-wrapper InputGroup-styles-read-only InputGroup-styles-disabled">
                <input id="MyDetails-fullName-input" readonly="" class="FieldInput-styles-no-text" name="fullName" type="text" disabled="" :value="user.firstName +' '+ user.lastName " />
              </div>
              <ul class="InputMessages-styles-input-messages"></ul>
              <ul class="InputWarnings-styles-input-messages"></ul>
            </div>
            <div class="InputGroup-styles-input-group MyDetailsForm-styles-field">
              <label class="InputGroup-styles-label" for="MyDetails-username-input">{{ t.user.username }}:</label>
              <div class="InputGroup-styles-input-wrapper InputGroup-styles-read-only InputGroup-styles-disabled">
                <input id="MyDetails-username-input" readonly="" class="FieldInput-styles-no-text" name="username" type="text" disabled="" :value="user.username" />
              </div>
              <ul class="InputMessages-styles-input-messages"></ul>
              <ul class="InputWarnings-styles-input-messages"></ul>
            </div>
            <div class="InputGroup-styles-input-group MyDetailsForm-styles-field">

              <ul class="InputMessages-styles-input-messages"></ul>
              <ul class="InputWarnings-styles-input-messages"></ul>
            </div>
            <div class="InputGroup-styles-input-group MyDetailsForm-styles-field">
              <label class="InputGroup-styles-label" for="MyDetails-birthday-input">{{ t.user.date_of_brith }}:</label>
              <div class="InputGroup-styles-input-wrapper InputGroup-styles-read-only InputGroup-styles-disabled">
                <input id="MyDetails-birthday-input" readonly="" class="FieldInput-styles-no-text" name="birthday" type="text" disabled="" :value="user.dateOfBirth | moment(session.date_format, session.timezone)" />
              </div>
              <ul class="InputMessages-styles-input-messages"></ul>
              <ul class="InputWarnings-styles-input-messages"></ul>
            </div>
            <div class="InputGroup-styles-input-group MyDetailsForm-styles-field">
              <label class="InputGroup-styles-label" for="MyDetails-email-input">E-mail:</label>
              <div class="InputGroup-styles-input-wrapper InputGroup-styles-disabled">
                <input id="MyDetails-email-input" readonly="" class="FieldInput-styles-no-text" name="email" type="email" validate="isNotNull,isValidEmail" :value="user.email" />
              </div>
              <ul class="InputMessages-styles-input-messages"></ul>
              <ul class="InputWarnings-styles-input-messages"></ul>
            </div>
            <button class="Button-styles-button Button-styles-secondary Button-styles-general MyDetailsForm-styles-form-button"><div class="">{{ t.edit }}</div></button>
          </form>
        </div>
      </div>

      <div class="MyDetails-styles-personal-details MyDetails-styles-desktop" v-if="page === 2">
        <div class="MyDetailsForm-styles-my-details MyDetailsForm-styles-desktop">
          <changePassword />
        </div>
      </div>

    </div>
  </div>
  <!-- <div class="user-information">
     <div class="main-space">
       <div class="sheet-l float-left">
         <span class="main-header">Kullanıcı verileri</span>
       </div>
       <div class="sheet-r float-right">&nbsp;</div>
       <div class="sheet-l float-left bg-grey">
         Kullanıcı adı
       </div>
       <div class="sheet-r float-right bg-grey">{{ user.username }}</div>
       <div class="sheet-l float-left ">
         Cinsiyet
       </div>
       <div class="sheet-r float-right">Bay</div>
       <div class="sheet-l float-left bg-grey">
         Ad
       </div>
       <div class="sheet-r float-right bg-grey">{{ user.firstName }} {{ user.middleName }}</div>
       <div class="sheet-l float-left ">
         Soyad
       </div>
       <div class="sheet-r float-right ">{{ user.lastName }}</div>
       <div class="sheet-l float-left bg-grey">
         Doğum Tarihi
       </div>
       <div class="sheet-r float-right bg-grey">{{
           user.dateOfBirth | moment(session.date_format, session.timezone)
         }}
       </div>
       <div class="sheet-l float-left ">
         E-posta
       </div>
       <div class="sheet-r float-right ">{{ user.email }}</div>
       <div class="sheet-l float-left bg-grey">
         Timezone
       </div>
       <div class="sheet-r float-right bg-grey">Otomatik</div>
     </div>
     <div class="hr bg-darkgrey clear"></div>
     <div class="main-space">
       <div class="sheet-l float-left">
         <span class="main-header">İletişim Bilgileri</span>
       </div>
       <div class="sheet-r float-right">&nbsp;</div>
       <div class="sheet-l float-left bg-grey">
         Adres
       </div>
       <div class="sheet-r float-right bg-grey">{{ user.homeAddress }}</div>
       <div class="sheet-l float-left ">
         Vatandaşlık numarası
       </div>
       <div class="sheet-r float-right">{{ user.idendifierNo }}</div>
       <div class="sheet-l float-left bg-grey">
         Ülke
       </div>
       <div class="sheet-r float-right bg-grey">{{ user.region.name }}</div>
       <div class="sheet-l float-left ">
         Cep telefonu
       </div>
       <div class="sheet-r float-right ">+{{ user.mobilePhone.country_code }} {{
           user.mobilePhone.national_number
         }}
       </div>
       <div class="sheet-l float-left bg-grey">
         Kur
       </div>
       <div class="sheet-r float-right bg-grey">{{ user.currency.iso_code }}</div>
     </div>
     <div class="hr bg-darkgrey clear"></div>
     <div class="button-main float-left">
       <router-link to="/limits" tag="button" class="button-180 grey">Limitler ve engellemeler</router-link>
     </div>
     <div class="button-main float-left">
       <router-link to="/change-password" tag="button" class="button-180 grey">Şifre ve Güvenlik</router-link>
     </div>
     <div class="button-main float-left">
       <button type="button" class="button-180 grey">Belge yükle</button>
     </div>
   </div> !-->
</template>

<script>

import changePassword from '@/components/user/form/changePassword'
export default {
  name: "userInfo",
  components: {changePassword},
  data() {
    return {
      session: this.$root.session,
      t: this.$root.t,
      isLoading: false,
      uid: 0,
      page: 1,
      user: {}
    }
  },
  mounted() {
    this.uid = this.$route.params.id;
    this.fetchUser(this.uid);
  },
  methods: {
    changePage(p) {
      this.page = p
    },
    fetchUser(uid) {
      if (!this.isLoading) {
        this.isLoading = true;
        this.$http.get(api + 'api/v1/users?uid=' + session.uid,
            {params: this.$route.query})
            .then(response => {
              this.pagination = response.body.result.pagination;
              this.user = response.body.result.users[0];
              this.status = response.status;
              this.isLoading = false;
            }, response => {
              this.isLoading = false;
              this.status = response.status;
            })
      }
    }
  }
}
</script>
.SidebarLayout-styles-content {
  padding: 50px;
}
<style scoped>

.bg-grey {
  background: #ebebeb;
}

.bg-darkgrey {
  background: #999999;
}

.clear {
  clear: both;
}

.hr {
  height: 1px;
  background-repeat: repeat-x;
  overflow: hidden;
  margin: 0;
}

.user-information {
  background: #fff;
}

.user-information h1 {
  padding: 12px 0 4px 12px;
  margin-bottom: 10px;
  color: #7c7c7c;
  border-bottom: 3px solid #7c7c7c;
  font-size: 15px;
  line-height: 20px;
}

.sheet-l {
  width: 25%;
  height: 24px;
  line-height: 24px;
  color: #666;
  text-align: right;
  padding-right: 20px;
  font-size: 11px;
}

.sheet-r {
  width: 75%;
  min-height: 24px;
  line-height: 24px;
  font-size: 12px;
  color: #000;
}

.sheet-l .main-header {
  color: #000;
  font-weight: bold;
}

.button-main {
  width: 180px;
  padding-right: 12px;
  min-height: 1px;
  position: relative;
}

.button-180.grey {
  width: 180px;
  height: 24px;
  cursor: pointer;
  background: #3c3c3c;
  padding-bottom: 2px;
  margin: 10px 0 10px 10px;
  line-height: 22px;
}

.button-180 {
  font-size: 14px;
  text-decoration: none;
  display: block;
  color: white;
  text-align: center;
}

.button-180:hover {
  color: #ef8107;
}
</style>



// WEBPACK FOOTER //
// src/components/user/userInfo.vue